function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3353 17.339H14.6698V13.1623C14.6698 12.1663 14.6495 10.8845 13.2808 10.8845C11.891 10.8845 11.6787 11.9682 11.6787 13.0887V17.339H9.01325V8.75H11.5738V9.92075H11.6083C11.966 9.24575 12.836 8.53325 14.1357 8.53325C16.8365 8.53325 17.336 10.3108 17.336 12.6245L17.3353 17.339ZM6.00275 7.57475C5.14475 7.57475 4.4555 6.88025 4.4555 6.026C4.4555 5.1725 5.1455 4.47875 6.00275 4.47875C6.85775 4.47875 7.55075 5.1725 7.55075 6.026C7.55075 6.88025 6.857 7.57475 6.00275 7.57475ZM7.33925 17.339H4.66625V8.75H7.33925V17.339ZM18.6688 2H3.32825C2.594 2 2 2.5805 2 3.29675V18.7032C2 19.4202 2.594 20 3.32825 20H18.6665C19.4 20 20 19.4202 20 18.7032V3.29675C20 2.5805 19.4 2 18.6665 2H18.6688Z",
  fill: "black"
});

function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.9ca21843.svg";
export { ForwardRef as ReactComponent };